<template>
  <div class="renewal-order-detail">
    <orderInfo :orderDetail="orderDetail" />
    <packageInfo :orderDetail="orderDetail" />
    <renewalBill :payInfoDetail="orderDetail.payInfoDetail" />
    <storeInfo v-if="orderDetail.id" :id="orderDetail.id" />
  </div>
</template>

<script>
import orderInfo from '../../../components/orderDetail/orderInfo.vue';
import packageInfo from '../../../components/orderDetail/packageInfo.vue';
import renewalBill from '../../../components/orderDetail/renewalBill.vue';
import storeInfo from '../../../components/orderDetail/storeInfo.vue';
export default {
  name: 'renewalOrderDetail',
  components: { orderInfo, packageInfo, renewalBill, storeInfo },
  props: {
    id: {
      type: String
    }
  },
  created() {
    this.getRenewalOrderDetail();
  },
  data() {
    return {
      orderDetail: {}
    };
  },
  methods: {
    async getRenewalOrderDetail() {
      const res = await Fetch.getRenewalOrderDetail({ id: this.id });
      this.orderDetail = res;
    }
  }
};
</script>

<style lang="scss" scoped>
.renewal-order-detail {
  padding: 0 24px 24px;
}
</style>
